import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { UserApiService } from '../../shared/services/api/user-api.service';
import { USER_PERMISSIONS_MANAGE } from './user-permissions.constants';

/**
 * Route guard for the super-user permission-management surface
 * (`/admin/permissions`), GF-4659.
 *
 * Reads the caller's DB-granted permissions from `GET /user/auth/me` and
 * activates the route only if `user_permissions.manage` is present. Everyone
 * else — tenant users and super_users without the grant — is bounced to
 * `/home`. Mirrors `dataScopeAdminGuard`, different permission key.
 */
export const userPermissionsAdminGuard: CanActivateFn = async () => {
  const userApi = inject(UserApiService);
  const router = inject(Router);
  try {
    const me = await firstValueFrom(userApi.getUserData());
    if (me.permissions?.includes(USER_PERMISSIONS_MANAGE)) {
      return true;
    }
  } catch {
    // Network / auth issues fall through to redirect — the authTokenInterceptor
    // already handles the 401/403 cases at the HTTP layer.
  }
  return router.createUrlTree(['/home']);
};
